export function animateFlyToCart({ sourceEl, cartEl }) {
  try {
    if (!sourceEl || !cartEl) return;

    const sourceRect = sourceEl.getBoundingClientRect();
    const getCartRect = () => cartEl.getBoundingClientRect();
    // Fixed duration (consistent top/bottom + all screens)
    const durationMs = 1800;

    const start = () => {
      const cartRect = getCartRect();

      // Create a small flying dot (cheaper than cloning images)
      const dot = document.createElement('div');
      dot.setAttribute('aria-hidden', 'true');
      Object.assign(dot.style, {
        position: 'fixed',
        left: `${sourceRect.left + sourceRect.width / 2}px`,
        top: `${sourceRect.top + sourceRect.height / 2}px`,
        width: '24px',
        height: '24px',
        borderRadius: '999px',
        background: 'var(--main-600, #ff6b6b)',
        boxShadow: '0 10px 25px rgba(0,0,0,0.18)',
        zIndex: 99999,
        pointerEvents: 'none',
        transform: 'translate(-50%, -50%) scale(1)',
        opacity: '1',
        transition:
          // Start slow, end faster (ease-in feel)
          `left ${durationMs}ms cubic-bezier(.15,0,.65,1), top ${durationMs}ms cubic-bezier(.15,0,.65,1), transform ${durationMs}ms cubic-bezier(.15,0,.65,1), opacity ${durationMs}ms linear`,
      });

      document.body.appendChild(dot);

      requestAnimationFrame(() => {
        dot.style.left = `${cartRect.left + cartRect.width / 2}px`;
        dot.style.top = `${cartRect.top + cartRect.height / 2}px`;
        dot.style.transform = 'translate(-50%, -50%) scale(0.45)';
        dot.style.opacity = '0.2';
      });

      const cleanup = () => {
        dot.removeEventListener('transitionend', cleanup);
        if (dot.parentNode) dot.parentNode.removeChild(dot);
      };
      dot.addEventListener('transitionend', cleanup);
      // Safety cleanup
      window.setTimeout(cleanup, durationMs + 650);
    };

    // If cart is offscreen (desktop scrolled down), peek header-middle then start after it settles a bit.
    const initialCartRect = getCartRect();
    const isOffscreen =
      initialCartRect.top < -20 ||
      initialCartRect.left < -20 ||
      initialCartRect.top > window.innerHeight + 20 ||
      initialCartRect.left > window.innerWidth + 20;

    if (isOffscreen) {
      const isDesktop = typeof window !== 'undefined' && window.matchMedia
        ? window.matchMedia('(min-width: 992px)').matches
        : true;
      if (isDesktop) {
        const headerMiddle = document.getElementById('header-middle');
        if (headerMiddle) {
          headerMiddle.classList.remove('header-middle-peek');
          void headerMiddle.offsetWidth;
          headerMiddle.classList.add('header-middle-peek');
        }
        // Wait until the peek animation reaches its visible/settled position
        // (so the dot targets the real cart position).
        window.setTimeout(start, 650);
        return;
      }
    }

    start();
  } catch {
    // no-op (animation must never break checkout flow)
  }
}

export function bumpCartIcon(cartEl) {
  if (!cartEl) return;
  cartEl.classList.remove('cart-bump');
  // Force reflow to restart animation reliably
  void cartEl.offsetWidth;
  cartEl.classList.add('cart-bump');
  window.setTimeout(() => cartEl.classList.remove('cart-bump'), 1100);
}

